import { useState } from "react";
import { Store } from "@tldraw/store";
import type { TLAssetStore, TLStore } from "@tldraw/tlschema";
import type { Editor } from "./canvas";
import { schema } from "../shared/schema";
import { BoardCanvas } from "./BoardCanvas";

// A local canvas for the landing and corridor demos: the board's shapes and
// tools, but no sync, uploads, pasting or customer data.

const noUploads: TLAssetStore = {
  upload: async () => {
    throw new Error("The demo does not keep files.");
  },
  resolve: (asset) => asset.props.src,
};

export function LocalCanvas({ onMount }: { onMount(editor: Editor): (() => void) | void }) {
  const [store] = useState(
    () =>
      new Store({
        schema,
        props: { defaultName: "", assets: noUploads, onMount: () => {} } as never,
      }) as unknown as TLStore,
  );
  return (
    <BoardCanvas
      store={store}
      onMount={(ed) => {
        for (const type of ["files", "url", "text", "content"])
          ed.registerExternalContentHandler(type, null);
        return onMount(ed as unknown as Editor);
      }}
    />
  );
}
